var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 12.5003C7.04265 11.1977 9.27865 11.1363 10.5007 12.5003M9.46065 8.50033C9.46065 9.23699 8.87998 9.83366 8.16265 9.83366C7.44598 9.83366 6.86465 9.23699 6.86465 8.50033C6.86465 7.76366 7.44598 7.16699 8.16265 7.16699C8.87932 7.16699 9.46132 7.76366 9.46132 8.50033",
    stroke: "#38B000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.16797C4.73733 3.17464 3.794 3.23597 3.18333 3.81464C2.5 4.46197 2.5 5.50397 2.5 7.58797V10.746C2.5 12.83 2.5 13.8726 3.18333 14.5193C3.86667 15.1673 4.96667 15.1673 7.16667 15.1673H9.16667C11.3667 15.1673 12.4667 15.1673 13.15 14.52C13.8333 13.872 13.8333 12.83 13.8333 10.7466V7.58797C13.8333 5.50397 13.8333 4.46197 13.15 3.81464C12.5393 3.23597 11.5967 3.17464 9.83333 3.16797",
    stroke: "#38B000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68116 2.9215C6.74516 2.64483 6.77716 2.50616 6.83849 2.3935C6.91475 2.25944 7.01849 2.14303 7.14293 2.05191C7.26736 1.9608 7.40967 1.89704 7.56049 1.86483C7.69583 1.8335 7.85316 1.8335 8.16649 1.8335C8.47983 1.8335 8.63716 1.8335 8.77249 1.86483C8.92332 1.89704 9.06562 1.9608 9.19006 2.05191C9.31449 2.14303 9.41824 2.25944 9.49449 2.3935C9.55583 2.50683 9.58783 2.64483 9.65183 2.9215L9.70716 3.1615C9.82049 3.6515 9.87716 3.89683 9.79183 4.0855C9.73367 4.21072 9.63911 4.3155 9.52049 4.38616C9.33316 4.50016 9.05449 4.50016 8.49849 4.50016H7.83449C7.27849 4.50016 6.99983 4.50016 6.81249 4.38683C6.69378 4.31599 6.59921 4.21096 6.54116 4.0855C6.45583 3.89683 6.51249 3.65216 6.62583 3.1615L6.68116 2.9215Z",
    stroke: "#38B000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdIcon);
export default __webpack_public_path__ + "static/media/id-icon.74083dcf6c7b7af76908fb3840934e16.svg";
export { ForwardRef as ReactComponent };